require('magnific-popup');

function init() {
  $('.login-trigger').on('click', function (e) {
    $.magnificPopup.open({
      type: 'inline',
      preloader: true,
      items: {
        src: '#login-modal',
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', init);



// WEBPACK FOOTER //
// ./scripts/sections/modal.js